import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AmazePlayerComponent } from 'amaze-player';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  nombreParam: string | null = null;
  apellidoParam: string | null = null;
  fechaParam: string | null = null;
  stateParam: string | null = null;
  srcParam: string | undefined = undefined;

  @ViewChild('player') player!: AmazePlayerComponent

  constructor(private route: ActivatedRoute) {}

  buttonHandler(e: any) {
    console.log('Button handler', e)
  }

  ngOnInit() {

    this.route.queryParams.pipe(
      filter(queryParams => Object.keys(queryParams).length > 0 === window.location.href.includes('?'))
    ).subscribe(params => {
      console.log("QUERY PARAMS:", params)
      this.nombreParam = params['nombre'];
      this.apellidoParam = params['apellido'];
      this.fechaParam = params['fecha'];
      this.stateParam = ['MASTERCARD-ORO', 'MASTERCARD-CLASICA'].includes(
        params['tarjeta']
      )
      ? params['tarjeta']
      : '';

      const url = params['src']
      if (url && url.startsWith('https://www.dropbox.com/')) {
        this.srcParam = url.replace('https://www.dropbox.com/', 'https://dl.dropboxusercontent.com/')
      } else {
        this.srcParam = url || 'assets/banco_v2.amz';
      }

    });
  }
}
